import { useState, useCallback } from "react";
import ExcelJS from "exceljs";
import { uploadDaysEntriesService } from "../services/uploadDaysEntriesService";


export const useUploadDaysEntries = ({ showGeneralMessage }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [previewData, setPreviewData] = useState([]);

  const fetchRecords = useCallback(async (startDate, endDate) => {
    setLoading(true);
    try {
      const res = await uploadDaysEntriesService.getRecordsRange(startDate, endDate);
      setData(res.data || []);
      setOriginalData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to retrieve records", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  // ADDED: Excel Parsing Logic moved from Modal to Hook
  const processExcelFile = async (file) => {
    setLoading(true);
    try {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(file);
      const worksheet = workbook.getWorksheet(1);
      const expandedLogs = [];

      // Fetch masterlist via Service
      const empRes = await uploadDaysEntriesService.getEmployeeMasterlist();
      const employees = empRes.data;

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const empNum = row.getCell(1).value?.toString();
        const daysWorked = parseFloat(row.getCell(2).value);
        const dateStart = new Date(row.getCell(3).value);
        const dateEnd = new Date(row.getCell(4).value);
        const employee = employees.find(e => e.employeeId === empNum);

        const diffTime = Math.abs(dateEnd - dateStart);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

        if (daysWorked > diffDays) {
          expandedLogs.push({ employeeNumber: empNum, fullName: employee?.fullName || "Unknown", errors: "Days worked exceeds range" });
          return;
        }

        let remainingDays = daysWorked;
        let currentDate = new Date(dateStart);
        for (let i = 0; i < diffDays && remainingDays > 0; i++) {
          const dayPortion = remainingDays >= 1 ? 1 : remainingDays;
          const workHours = dayPortion * 10;
          const tIn = new Date(currentDate); tIn.setHours(7, 0, 0);
          const tOut = new Date(tIn);
          tOut.setHours(tIn.getHours() + Math.floor(workHours));
          tOut.setMinutes(tIn.getMinutes() + (workHours % 1) * 60);

          expandedLogs.push({
            employeeNumber: empNum,
            fullName: employee?.fullName || "Not Found",
            date: new Date(currentDate).toISOString().split('T')[0],
            timeIn: tIn.toISOString(),
            timeOut: tOut.toISOString(),
            errors: employee ? null : "Emp ID not found"
          });
          remainingDays -= 1;
          currentDate.setDate(currentDate.getDate() + 1);
        }
      });
      setPreviewData(expandedLogs);
    } catch (err) {
      showGeneralMessage("Error processing Excel file", false);
    } finally {
      setLoading(false);
    }
  };

  const uploadBulkData = async (payload) => {
    setLoading(true);
    try {
      await uploadDaysEntriesService.bulkUpload(payload);
      showGeneralMessage("Records uploaded successfully!", true);
      return true;
    } catch (err) {
      showGeneralMessage(err.response?.data || "Failed to upload", false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    previewData,
    setPreviewData,
    processExcelFile,
    fetchRecords,
    uploadBulkData
  };
};